import React, { useEffect, useState } from 'react';

import usePrevious from '../hooks/usePrevious';
import useRequired from '../hooks/useRequired';
import useModal from '../hooks/useModal';
import useAsync from '../hooks/useAsync';

import Modal from '../components/Shell/Modal';
import {
	TemplateColor,
	TemplateField,
} from '../components/Attributes/Attributes_old';

import Button from '../components/Button';
import { TAG_COLOR_OPTIONS } from '../components/helpers/constants';
import { classNames } from '../components/helpers/functions';

import { addTag, deleteTag, updateTag } from '../api/tags';

const MODAL_NAME = 'addTagModal';
const ASSETS_MODULE_ID = process.env.REACT_APP_MODULE_ID_ASSETS;

const QuickAddTag = () => {
	const [form, setForm] = useState({});

	const { open: options, setClose } = useModal(MODAL_NAME);
	const {
		open: deleteModalOpen,
		setOpen: setDeleteModalOpen,
		setClose: setDeleteModalClose,
	} = useModal('deleteModal');

	const { execute: onAddTag, status: isAddingTag } = useAsync(addTag, {
		immediate: false,
		showNotification: {
			success: 'Successfully added tag',
		},
	});

	const { execute: onUpdateTag, status: isUpdatingTag } = useAsync(updateTag, {
		immediate: false,
	});

	const { execute: onDeleteTag, status: isDeletingTag } = useAsync(deleteTag, {
		immediate: false,
	});

	const prevOptions = usePrevious(options);

	useEffect(() => {
		if (options && !prevOptions) {
			if (!options?.color) {
				setForm({ ...options, color: TAG_COLOR_OPTIONS[0].key });
			} else {
				setForm(options);
			}
		}
	}, [options]);

	const onAction = form?.id ? onUpdateTag : onAddTag;
	return (
		<Modal
			title={form?.id ? 'Update tag' : 'Create a tag'}
			open={!!options}
			onClose={() => setClose()}
		>
			<div className="grid grid-cols-2 gap-y-4 gap-x-4 text-left">
				<TemplateField
					name="Label"
					value={form?.label}
					onChange={(index, label) => setForm({ ...form, label })}
				/>
				<TemplateColor
					name="Color"
					value={form?.color}
					defaultValue={TAG_COLOR_OPTIONS[0]?.key}
					onChange={(index, color) => setForm({ ...form, color })}
				/>
			</div>
			<div
				className={classNames(
					'flex mt-6',
					form?.id ? 'justify-between' : 'justify-end'
				)}
			>
				{form?.id ? (
					<Button
						type="danger"
						onClick={() =>
							setDeleteModalOpen({
								title: 'Are you sure you want to delete this tag?',
								confirmText: 'Delete',
								onConfirm: () =>
									onDeleteTag({ id: form?.id }, () => {
										setDeleteModalClose();
										setClose();
									}),
							})
						}
					>
						Delete
					</Button>
				) : null}
				<Button
					onClick={() => {
						onAction(
							{
								...(form?.id ? { id: form?.id } : {}),
								name: form?.label,
								color: form?.color,
								moduleId: ASSETS_MODULE_ID,
							},
							(response) => {
								if (typeof options?.onSubmit === 'function') {
									options?.onSubmit({
										label: response.name,
										value: response.id,
										color: response?.color,
									});
									setForm({});
								}
								setClose();
							}
						);
					}}
					disabled={!useRequired(form, ['label', 'color'])}
				>
					{form?.id
						? isUpdatingTag === 'pending'
							? 'Updating...'
							: 'Update'
						: isAddingTag === 'pending'
						? 'Creating...'
						: 'Create Tag'}
				</Button>
			</div>
		</Modal>
	);
};

export default QuickAddTag;
